export function formatPhoneNumber(number) {
  return number?.replace(/[()]/g, '').replace(/\s+/g, '').replace(/-/g, '');
}
